module.exports = __webpack_public_path__ + "img/icon_page5_phone.2d2f4951.png";